import { HeaderService } from 'src/app/core/services/header.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss']
})

export class PrincipalComponent implements OnInit  {
  headerService: HeaderService;

  constructor(headerService: HeaderService) {
    this.headerService = headerService;
  }

  ngOnInit() {
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

}
